import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters('entities', {
      subtaskEntities: 'subtasks',
    }),
    subtask () {
      return this.subtaskEntities[this.subtaskId];
    },
  },
};
